function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { dateFromUnixTimestamp as P, rehydrateDateAfterJsonization as V } from "../../util/date-utils.js";
import { logger as N } from "../../../shared-lib/index.js";
import ri from "./trigger-condition.js";
import { validateValueIsFromEnum as ta } from "../../util/code-utils.js";

var pt = /*#__PURE__*/function () {
  function pt(t) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var s = arguments.length > 2 ? arguments[2] : undefined;
    var e = arguments.length > 3 ? arguments[3] : undefined;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var h = arguments.length > 5 ? arguments[5] : undefined;
    var l = arguments.length > 6 ? arguments[6] : undefined;
    var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var n = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : pt.td;
    var a = arguments.length > 9 ? arguments[9] : undefined;
    var u = arguments.length > 10 ? arguments[10] : undefined;
    var d = arguments.length > 11 ? arguments[11] : undefined;

    _classCallCheck(this, pt);

    this.id = t, this.sd = i, this.startTime = s, this.endTime = e, this.priority = r, this.type = h, this.data = l, this.ed = o, this.rd = n, this.Jr = a, this.hd = u, this.od = d, this.id = t, this.sd = i || [], void 0 === s && (s = null), this.startTime = s, void 0 === e && (e = null), this.endTime = e, this.priority = r || 0, this.type = h, this.ed = o || 0, null == a && (a = 1e3 * (this.ed + 30)), this.Jr = a, this.data = l, null != n && (this.rd = n), this.hd = u, this.od = d || null;
  }

  _createClass(pt, [{
    key: "nd",
    value: function nd(t) {
      return null == this.od || this.rd !== pt.td && t - this.od >= 1e3 * this.rd;
    }
  }, {
    key: "ad",
    value: function ad(t) {
      this.od = t;
    }
  }, {
    key: "ud",
    value: function ud(t) {
      var i = t + 1e3 * this.ed;
      return Math.max(i - new Date().valueOf(), 0);
    }
  }, {
    key: "dd",
    value: function dd(t) {
      var i = new Date().valueOf() - t,
          s = null == t || isNaN(i) || null == this.Jr || i < this.Jr;
      return s || N.info("Trigger action ".concat(this.type, " is no longer eligible for display - fired ").concat(i, "ms ago and has a timeout of ").concat(this.Jr, "ms.")), !s;
    }
  }, {
    key: "bt",
    value: function bt() {
      var t = [];

      for (var i = 0; i < this.sd.length; i++) {
        t.push(this.sd[i].bt());
      }

      return {
        i: this.id,
        c: t,
        s: this.startTime,
        e: this.endTime,
        p: this.priority,
        t: this.type,
        da: this.data,
        d: this.ed,
        r: this.rd,
        tm: this.Jr,
        ss: this.hd,
        ld: this.od
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      var i = t.id,
          s = [];

      for (var _i = 0; _i < t.trigger_condition.length; _i++) {
        s.push(ri.fromJson(t.trigger_condition[_i]));
      }

      var e = P(t.start_time),
          r = P(t.end_time),
          h = t.priority,
          l = t.type,
          o = t.delay,
          n = t.re_eligibility,
          a = t.timeout,
          u = t.data,
          d = t.min_seconds_since_last_trigger;
      return ta(pt.Or, l, "Could not construct Trigger from server data", "Trigger.Types") ? new pt(i, s, e, r, h, l, u, o, n, a, d) : null;
    }
  }, {
    key: "Rn",
    value: function Rn(t) {
      var i = [],
          s = t.c || [];

      for (var _t = 0; _t < s.length; _t++) {
        i.push(ri.Rn(s[_t]));
      }

      return new pt(t.i, i, V(t.s), V(t.e), t.p, t.t, t.da, t.d, t.r, t.tm, t.ss, t.ld);
    }
  }]);

  return pt;
}();

export { pt as default };
pt.Or = {
  Cr: "inapp",
  md: "templated_iam"
}, pt.td = -1;